import { ICustomerList } from '../../inter/list';

const Item = ({
  props,
  action,
}: {
  props: ICustomerList;
  action(
    id: string,
    info: {
      name: string;
      email: string;
    },
  ): void;
}): JSX.Element => {
  return (
    <div className="bg-white flex justify-between items-center rounded-md shadow-xs text-sm">
      <div className="px-4 py-4 text-left w-[350px] font-medium">
        {props.name}
      </div>
      <div className="w-[350px] px-2 py-4">{props.email}</div>
      <div className="w-[200px] px-2 py-4">{props.phone}</div>
      <div className="min-w-[150x] flex-1 px-2 py-4">
        <button
          type="button"
          className="text-indigo-600 font-medium"
          onClick={() => {
            action(props.id, { name: props.name, email: props.email });
          }}
        >
          {props._count.comments} tương tác
        </button>
      </div>
    </div>
  );
};

export default Item;
